import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";

export const selectFilesState = (state: RootState) => state.filesState;

export const selectFilesValue = createSelector(
  selectFilesState,
  (state) => state.filesValue,
);

export const selectFileHash = createSelector(
  selectFilesState,
  (state) => state.filesValue?.userfiles.hash ?? "",
);

export const selectFileName = createSelector(selectFilesValue, (state) => {
  return state?.userfiles.filename;
});

export const selectFileExtensions = createSelector(
  selectFilesValue,
  (state) => {
    return state?.userfiles.filename.split(".").pop() || "bin";
  },
);

export const selectFileConfig = createSelector(
  selectFilesState,
  (state) => state.fileConfig,
);

export const selectIsFileLoading = createSelector(
  selectFilesState,
  (state) => state.isFileLoading,
);
